<template>
  <div class="add-base">
    <user-detail-title
      first-bread="标签管理"
      second-bread="产品信息"
      third-bread="产品信息添加"
      first-url="/user/sign"
      second-url="/user/product_info"
      title-name="产品信息添加"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="Alist.name" ></el-input>
        </el-form-item>
        <el-form-item label="主图">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="型号">
          <el-input v-model="Alist.modelNumber" ></el-input>
        </el-form-item>
        <el-form-item label="品牌">
          <el-checkbox-group v-model="Alist.labelList" v-if="BelongData.label">
            <el-checkbox v-for="  (item,index) in BelongData.label" :key="index+'sw'" :label="item.id" v-if="item">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="型号">
          <el-checkbox-group v-model="Alist.classifyList" v-if="BelongData.classify">
            <el-checkbox v-for=" (item,index) in BelongData.classify" :key="index+'ss'" :label="item.id" v-if="item">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="商品介绍">
          <ripeav-text-input v-model="Alist.productIntroduce"  />
        </el-form-item>
        <el-form-item label="预览">
          <div v-html="Alist.productIntroduce" />
        </el-form-item>
      </el-form>
    </user-detail-base>
    <el-button @click="handleAdd">添加</el-button>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  import RipeavTextInput from "@/components/tinymce/RipeavTextInput";
  export default {
    name: "ProductInfoAdd",
    components: {RipeavTextInput, UserDetailBase, UserDetailTitle},
    data(){
      return{
        BelongData:null,
        Alist: {
          'name':null,
          'modelNumber':null,
          'photoUrl':null,
          'labelList':[],
          'classifyList':[],
          'productIntroduce':null,
        },//表示Add添加的数据
      }
    },
    created() {
      this.GetBelong()

    },
    methods:{

      GetUrlList(file){
        this.Alist.photoUrl=file.data;
      },
      GetBelong(){
        this.$axios.get('/api/productInfo/getProductBelong').then(res=>{
          this.BelongData=res.data.data;
        })
      },
      handleAdd(){
        this.$axios.post('/api/productInfo/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'name':null,
              'modelNumber':null,
              'photoUrl':null,
              'labelList':[],
              'classifyList':[],
              'productIntroduce':null,
            },
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>